import { Modal } from '@material-ui/core'
import { ReviewPromptPlatform } from '@shared/core/billing'
import { GetProfileResponseDto } from '@shared/core/users'
import { Widget } from '@typeform/embed-react'
import { useEffect } from 'react'
import classes from './g2-capterra-review-modal.module.scss'
import { buildG2CapterraReviewHiddenFields, getG2CapterraReviewModalContent } from './g2-capterra-review-modal.utils'

export interface G2CapterraReviewModalProps {
  open: boolean
  onClose: () => void
  onShown: () => void
  reviewPlatform: ReviewPromptPlatform
  profile: GetProfileResponseDto
}

export function G2CapterraReviewModal({ open, onClose, onShown, reviewPlatform, profile }: G2CapterraReviewModalProps) {
  useEffect(() => {
    if (open) {
      onShown()
    }
  }, [open, onShown])

  if (!open) {
    return null
  }

  const { formId, title } = getG2CapterraReviewModalContent(reviewPlatform)

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div className={classes.modalBox}>
        <button type="button" className={classes.closeButton} onClick={onClose}>
          <svg className={classes.closeIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#0F1729"
            />
          </svg>
        </button>
        <h2 id="modal-title" className={classes.modalTitle}>
          {title}
        </h2>
        <div className={classes.widgetContainer}>
          <Widget
            id={formId}
            style={{ width: '100%', height: '100%' }}
            hidden={buildG2CapterraReviewHiddenFields(profile)}
          />
        </div>
      </div>
    </Modal>
  )
}
